var R = /* @__PURE__ */ ((E) => (E[E.CURRENT = 1] = "CURRENT", E[E.CURSOR = 2] = "CURSOR", E[E.WEEKEND = 4] = "WEEKEND", E[E.LINE_START = 8] = "LINE_START", E[E.LINE_END = 16] = "LINE_END", E[E.WITHIN_BLOCK = 32] = "WITHIN_BLOCK", E[E.BLOCK_START = 64] = "BLOCK_START", E[E.BLOCK_END = 128] = "BLOCK_END", E[E.WITHIN_RANGE = 256] = "WITHIN_RANGE", E[E.RANGE_START = 512] = "RANGE_START", E[E.RANGE_END = 1024] = "RANGE_END", E[E.WITHIN_SELECTION = 2048] = "WITHIN_SELECTION", E[E.SELECTION_START = 4096] = "SELECTION_START", E[E.SELECTION_END = 8192] = "SELECTION_END", E[E.ALL = 16383] = "ALL", E))(R || {}), N = /* @__PURE__ */ ((E) => (E[E.PREV = 1] = "PREV", E[E.BLOCK = 0] = "BLOCK", E[E.FRAME = 2] = "FRAME", E[E.PERIOD = 4] = "PERIOD", E))(N || {}), _ = /* @__PURE__ */ ((E) => (E[E.PREV_PERIOD = 5] = "PREV_PERIOD", E[E.PREV_FRAME = 3] = "PREV_FRAME", E[E.PREV = 1] = "PREV", E[
  E.NEXT = 0
  /* BLOCK */
] = "NEXT", E[
  E.NEXT_FRAME = 2
  /* FRAME */
] = "NEXT_FRAME", E[
  E.NEXT_PERIOD = 4
  /* PERIOD */
] = "NEXT_PERIOD", E))(_ || {});
export {
  N as CalendarShiftControlFlag,
  _ as CalendarShiftControlsFlag,
  R as TimeFlag
};
